import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/** Components */
import Table from 'components/Table';
import Loader from 'components/Loader';
/** Services */
import { getSuppliersContracts } from 'services/contracts';
/** Utils */
import { createToast } from 'utils/toast';
/** Constants */
import { CONTRACT_HEAD_CELLS } from 'constants/providers';
/** Styles */
import './Contratos.scss';

const Contratos = ({ provider }) => {
  const navigate = useNavigate();
  const [contractList, setContractList] = useState([]);
  const [loading, setLoading] = useState(true);

  console.log(111, contractList);

  useEffect(() => {
    getSuppliersContracts()
      .then(({ status, data: { suppliersContracts } }) => {
        if (status === 200) {
          const mappedContracts = suppliersContracts.filter(
            (contract) => contract.SupplierId === provider
          );
          setContractList(mappedContracts);
        }
        setLoading(false);
      })
      .catch(({ status }) => {
        setLoading(false);
        if (status === 401) {
          createToast({
            text: 'No tienes suficientes permisos',
            type: 'error',
          });
          return;
        }
        if (status === 404) {
          createToast({
            text: 'No existen contratos de proveedores',
            type: 'error',
          });
          return;
        }

        createToast({ text: 'Algo ha salido mal', type: 'error' });
      });
  }, []);

  const mappedClients = contractList.map(
    ({ contractNumber = '', contractDate = '', Supplier, id }) => {
      return {
        ...(contractNumber
          ? { contractNumber }
          : { contractNumber: 'Sin nº de contrato' }),
        ...(Supplier
          ? { SupplierId: Supplier.name }
          : { SupplierId: 'Sin proveedor' }),
        ...(contractDate ? { contractDate } : { contractDate: 'Sin fecha' }),
        ...(id && { id }),
      };
    }
  );

  const handleSelectContract = (contractId) => {
    navigate(`/proveedores/contratos/${contractId}`);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {contractList.length !== 0 ? (
        <Table
          rowsData={mappedClients}
          headCells={CONTRACT_HEAD_CELLS}
          ignoreColumn="id"
          targetItem="id"
          setItem={handleSelectContract}
        />
      ) : (
        <div className="EmptyState">No hay Contratos.</div>
      )}
    </>
  );
};

export default Contratos;
